module.exports = __webpack_public_path__ + "static/media/elements_section2_slide5.454d7b84.png";